import { MatchStateFilter, TournamentStateFilter } from '@okletsplay/core';
import { SessionState } from './interfaces';
import { SessionStoreStatus } from './enums';

export const initialState: SessionState = {
  entity: {
    user: {},
    redirect: {},
    isChatPinned: false,
    isLeaderboardExpanded: true,
    matchFilter: MatchStateFilter.All,
    tournamentFilter: TournamentStateFilter.All,
  },
  status: {
    [SessionStoreStatus.Loading]: [],
  },
};
